import { lazy } from "react";
import ProtectedRoute from "../components/shared/ProtectedRoute";
import { Route, Routes } from "react-router-dom";

const OrdersAnalytics = lazy(() => import("../pages/Analytics/OrdersAnalytics"));
const UsersAnalytics = lazy(() => import("../pages/Analytics/UsersAnalytics"));

export default function AnalyticsRoutes() {
  return (
    <Routes>
      <Route
        path="/orders"
        element={
          <ProtectedRoute permission="view_order">
            <OrdersAnalytics />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute permission="view_customer">
            <UsersAnalytics />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
} 